// extracted by mini-css-extract-plugin
export default {"ns_title":"NSTitle_ns_title__1TtN6"};